import { useNetworksStateContext } from "../contexts/NetworksContext"

export function useExtendWithSubnetworks(parameters, module = null, fieldName = "sub_networks", subNetworks = null) {

    const { selectedSubNetworkSlugs } = useNetworksStateContext()
    const { selectedNetwork } = useNetworksStateContext()
    const currentSubNetworks = selectedNetwork?.children?.length ? (subNetworks || selectedSubNetworkSlugs).map(selectedNetworkSlug => {
        return selectedNetwork.children.find(child => child.slug === selectedNetworkSlug)
    }) : null

    const availableSubNetworksSlugsForSubModule = currentSubNetworks
        ?.filter(child => !module || child.modules?.includes(module))
        ?.map(sub => sub.slug) || []

    const extendedFields = (availableSubNetworksSlugsForSubModule?.length > 0) && { [fieldName]: availableSubNetworksSlugsForSubModule.join(",") }

    if (Array.isArray(parameters)) {
        return parameters.map(parameter => ({
            ...parameter,
            ...extendedFields,
        }))
    }

    return {
        ...parameters,
        ...extendedFields,
    }
}